import state from '@/vuex/auth/state.js'
import getters from '@/vuex/auth/getters.js'
import mutations from '@/vuex/auth/mutations.js'
import actions from '@/vuex/auth/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
